import { isFunction } from 'lodash'
import { createHeaderCellContentWrap } from './cell-content-wrap'
import { createHeaderCellOptions } from './cell-options'

const CellContentWrap = createHeaderCellContentWrap()
const CellOptions = createHeaderCellOptions()

export function createHeaderCell () {
  return {
    functional: true,
    render (h, context) {
      const props = context.props
      const { column, headerAlign, store, columnIndex, rowIndex, handleEvent } = props
      const {
        label,
        placeholderSign,
        headerCellRender,
        headerCellRenderToLeft,
        headerCellRenderToRight
      } = column
      const [$slots] = context.children

      const renderInnerCell = () => {
        if (headerCellRender) {
          return headerCellRender(h, props, context)
        } else if ($slots.headerCell) {
          return isFunction($slots.headerCell) ? $slots.headerCell({column, rowIndex, columnIndex}) : $slots.headerCell
        } else {
          const createCellSpan = () => {
            const mouseenter = (event) => {
              handleEvent && handleEvent(event, { column, eventType: 'label-mouse-enter', rowIndex, columnIndex, event })
            }
            const mouseleave = (event) => {
              handleEvent && handleEvent(event, { column, eventType: 'label-mouse-leave', rowIndex, columnIndex, event })
            }
            const clickEvent = (event) => {
              handleEvent && handleEvent(event, { column, eventType: 'label-click', rowIndex, columnIndex, event })
            }
            let displayLabel = placeholderSign || label
            if (isFunction(column.headerFormatter)) {
              displayLabel = column.headerFormatter(column, displayLabel, props)
            }
            return <span
              on-mouseenter={mouseenter}
              on-mouseleave={mouseleave}
              on-click={clickEvent}
            >{displayLabel}</span>
          }
          const spanInner = createCellSpan()
          const createCellOption = () => {
            const cellAttrs = {
              props,
              ref: 'cellOption'
            }
            return <CellOptions
              {...cellAttrs}
            ></CellOptions>
          }
          const childrenVnode = [
            spanInner
          ]
          if (headerCellRenderToLeft) {
            childrenVnode.unshift(headerCellRenderToLeft(h, context.props, context))
          }
          if (headerCellRenderToRight) {
            childrenVnode.push(headerCellRenderToRight(h, context.props, context))
          }
          const cellOption = createCellOption()
          childrenVnode.push(cellOption)
          return childrenVnode
        }
      }
      const InnerCell = renderInnerCell()
      const cellContentAttrs = {
        ref: 'cellContentWrap',
        props: {
          column,
          rowIndex,
          columnIndex,
          label,
          store,
          handleEvent,
          headerAlign
        }
      }
      return <CellContentWrap {...cellContentAttrs}>
        {
          InnerCell
        }
      </CellContentWrap>
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/header-thead/cell.js